function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 9L20 12.5M20 12.5L16 9M20 12.5V7M20 12.5V20M20 20L26.4952 23.75M20 20L13.5048 23.75M20 20L13.5048 16.25M20 20L20 27.5M20 20L26.4952 16.25M27.5263 28.9641L26.4952 23.75M26.4952 23.75L31.5263 22.0359M26.4952 23.75L31.2583 26.5M8.47369 22.0359L13.5048 23.75M13.5048 23.75L12.4737 28.9641M13.5048 23.75L8.74164 26.5M12.4737 11.0359L13.5048 16.25M13.5048 16.25L8.47369 17.9641M13.5048 16.25L8.74164 13.5M16 31L20 27.5M20 27.5L24 31M20 27.5L20 33M31.5263 17.9641L26.4952 16.25M26.4952 16.25L27.5263 11.0359M26.4952 16.25L31.2583 13.5",
  stroke: "#B2C9D9",
  strokeWidth: 2
});

var SvgSnow = function SvgSnow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSnow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snow.c3732ef3.svg";
export { ForwardRef as ReactComponent };